var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cardapio-digital-footer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"is-flex is-justify-content-center is-align-content-center"},[_c('a',{attrs:{"href":"http://www.spicesoftware.com.br/","target":"_blank"}},[_c('img',{attrs:{"src":_vm.caminho,"alt":"Footer"}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }